import React, { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import PalavraDoDia from "@/components/sections/PalavraDoDia";
import VaAlemLeiaTambem from "@/components/sections/VaAlemLeiaTambem";
import ContinuacaoJornada from "@/components/sections/ContinuacaoJornada";
import TemaDaSemanaHoje from "@/components/sections/TemaDaSemanaHoje";
import SermonOfTheDay from "@/components/sections/SermonOfTheDay";
import VideoDestaque from "@/components/sections/VideoDestaque";
import ExplorarPorCategoria from "@/components/sections/ExplorarPorCategoria";
import MinisterioEObras from "@/components/sections/MinisterioEObras";
import FinalCTA from "@/components/sections/FinalCTA";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import PromoBar from "@/components/PromoBar";
import WeeklyThemeBanner from "@/components/WeeklyThemeBanner";
import { trackPageView } from "@/lib/analytics";
import useDocumentMeta from "@/hooks/useDocumentMeta";

/**
 * Home Devocional-first (Iter 47/48 · V4 · GUIDE.md).
 *
 * Hierarquia:
 *   1. Palavra do Dia (protagonista único)
 *   2. Vá além, leia também (scripture_connections)
 *   3. Continuação de jornada (condicional, silêncio elegante quando null)
 *   4. Tema da Semana
 *   5. Sermão em destaque
 *   6. Vídeo em destaque
 *   7. Explorar por categoria (chips)
 *   8. Ministério e obras (bloco discreto)
 *   9. CTA Final
 *
 * Regras estritas:
 *  - NENHUM em-dash (—) ou en-dash (–) no conteúdo autoral do frontend.
 *  - Microcopy pastoral: convite, nunca pressão/culpa.
 */

const HOME_JSON_LD = {
  "@context": "https://schema.org",
  "@type": "Person",
  name: "Carlos Medeiros",
  jobTitle: "Pregador, Pastor e Autor",
  url: "https://cemedeiros.com.br/",
  image: "https://cemedeiros.com.br/couple-carlos-milena.jpg",
  description:
    "Pregador, pastor e autor. Devocionais diários, sermões, planos de leitura e ferramentas para crescimento espiritual.",
  sameAs: [
    "https://instagram.com/ccarlosmedeiross",
    "https://youtube.com/@conectadospelapalavra",
  ],
};

export default function Home() {
  useDocumentMeta({
    title: "Carlos Medeiros, Pregador, Autor e Pastor",
    description:
      "Devocional diário, palavras que aprofundam, tema da semana e mensagens pastorais para o crescimento do seu coração.",
    canonical: "https://cemedeiros.com.br/",
    url: "https://cemedeiros.com.br/",
    jsonLd: HOME_JSON_LD,
  });

  useEffect(() => {
    trackPageView();

    // Smooth scroll para âncoras internas
    const handler = (e) => {
      const a = e.target.closest('a[href^="/#"], a[href^="#"]');
      if (!a) return;
      const hash = a.getAttribute("href").replace("/", "");
      if (!hash.startsWith("#")) return;
      const el = document.querySelector(hash);
      if (el) {
        e.preventDefault();
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    };
    document.addEventListener("click", handler);
    return () => document.removeEventListener("click", handler);
  }, []);

  return (
    <div data-testid="home-page" className="bg-[#F7F5F0]">
      <PromoBar />
      <WeeklyThemeBanner mode="top" />
      <Navbar />
      <main>
        <PalavraDoDia />
        <VaAlemLeiaTambem />
        <ContinuacaoJornada />
        <TemaDaSemanaHoje />
        <SermonOfTheDay />
        <VideoDestaque />
        <ExplorarPorCategoria />
        <MinisterioEObras />
        <FinalCTA />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}
